import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.oauth2.RedirectPage', {
    qbooksVerifyEmail: 'Please verify your Intuit account before it can be used with ApprovalMax',
    verify: 'Verify',
});
